import {toast} from 'react-toastify';

/**
 * The UserSelectField stores each selection as "firstName;lastName;id;email".
 * Pull out just the user ids for the targetAudience.userIds payload. Handles
 * both the concatenated form and bare ids (e.g. when hydrated from a read where
 * only ids are available), so it's safe to call on already-clean data.
 */
export const extractUserIds = userIds =>
  (userIds || [])
    .map(user => {
      if (typeof user !== 'string') return user;
      return user.includes(';') ? user.split(';')[2] : user;
    })
    .filter(Boolean);

export const onTranslateAnnouncement = async (query, translateProps) => {
  const {sourceLang, targetLang, targetText1, targetText2, targetText3} =
    translateProps;
  try {
    const translations = [
      {sourceLang, sourceText: targetText1, targetLang},
      {sourceLang, sourceText: targetText2, targetLang},
    ];
    if (typeof targetText3 === 'string' && targetText3.trim() !== '') {
      translations.push({
        sourceLang,
        sourceText: targetText3,
        targetLang,
      });
    }

    const {data} = await query({
      variables: {translations, treatment: 'html'},
    });
    return {
      title: data.translateText.translations[0],
      subTitle: data.translateText.translations[1],
      ...(data.translateText.translations[2] && {
        actionButtonText: data.translateText.translations[2],
      }),
      language: targetLang,
    };
  } catch (error) {
    toast.error('Something went wrong');
  }
};
